import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import React from "react";
import { useIntl } from "react-intl";
import { COLOR_PRIMARY } from "../../../constants/theme";
import { SocialAutoPostsReadyNotification } from "../../../cores/notifications/interfaces/api/get-notifications";

interface Props {
  notification: SocialAutoPostsReadyNotification;
  variant?: "dropdown" | "page";
  isDarkMode?: boolean;
}

export default function SocialAutoPostsReadyNotificationItem({
  notification,
  variant = "dropdown",
  isDarkMode = false,
}: Props) {
  const intl = useIntl();
  const projectName =
    notification.projectName?.trim() ||
    intl.formatMessage({
      id: "app.notifications.socialAutoPosts.defaultProject",
      defaultMessage: "tu proyecto",
    });
  const total = notification.total || notification.done || 0;

  if (variant === "page") {
    return (
      <div
        className={cn("new-contact-notification-page", {
          "new-contact-notification-page--dark": isDarkMode,
        })}
      >
        <div className="new-contact-notification-page__icon">
          <FontAwesomeIcon
            icon={["fas", "wand-magic-sparkles"]}
            size="2x"
            color={COLOR_PRIMARY}
          />
        </div>
        <div className="new-contact-notification-page__body">
          <p className="new-contact-notification-page__eyebrow">
            {intl.formatMessage({
              id: "app.notifications.kind.socialAutoPostsReady",
              defaultMessage: "Publicaciones IA",
            })}
          </p>
          <p className="new-contact-notification-page__title">
            {intl.formatMessage(
              {
                id: "app.notifications.socialAutoPosts.title",
                defaultMessage: "Contenido de \"{project}\" listo",
              },
              { project: projectName }
            )}
          </p>
          <p className="new-contact-notification-page__success">
            {intl.formatMessage(
              {
                id: "app.notifications.socialAutoPosts.body",
                defaultMessage:
                  "{count, plural, one {# publicación generada} other {# publicaciones generadas}}. Ya puedes revisarlas y programarlas.",
              },
              { count: total }
            )}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center overflow-hidden">
      <FontAwesomeIcon
        icon={["fas", "wand-magic-sparkles"]}
        className="mr-3"
        color={COLOR_PRIMARY}
      />
      <div className="d-flex flex-column overflow-hidden">
        <span>
          {intl.formatMessage(
            {
              id: "app.notifications.socialAutoPosts.title",
              defaultMessage: "Contenido de \"{project}\" listo",
            },
            { project: projectName }
          )}
        </span>
        <span className="text-truncate text-muted">
          {intl.formatMessage(
            {
              id: "app.notifications.socialAutoPosts.bodyShort",
              defaultMessage:
                "{count, plural, one {# publicación lista para revisar} other {# publicaciones listas para revisar}}",
            },
            { count: total }
          )}
        </span>
      </div>
    </div>
  );
}
